module.exports = __webpack_public_path__ + "img/live-lectures.0d75f538.png";